(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    const wickScentLightboxes = new WeakSet();

document.addEventListener("lightbox:open", (event) => {
  if (!(event.target instanceof Element)) return;

  const gallery = event.target.closest("product-gallery");
  const source = gallery?.querySelector(".wick-scent-gallery__badge-image");
  if (!source || !gallery.hasAttribute("allow-zoom")) return;

  const lightbox = gallery.photoswipe;
  if (!lightbox || wickScentLightboxes.has(lightbox)) return;
  wickScentLightboxes.add(lightbox);

  lightbox.on("uiRegister", () => {
    lightbox.pswp.ui.registerElement({
      name: "wick-scent-badge",
      className: "wick-scent-zoom",
      isButton: false,
      appendTo: "wrapper",
      onInit: (element, pswp) => {
        const image = source.cloneNode(true);
        image.className = "wick-scent-zoom__image";
        image.loading = "eager";
        element.appendChild(image);

        let frame = 0;
        const update = () => {
          frame = 0;
          const slideImage = pswp.currSlide?.content?.element;
          const viewport = element.parentElement;
          if (!viewport || !slideImage?.isConnected || slideImage.tagName !== "IMG") {
            element.style.visibility = "hidden";
            return;
          }

          const bounds = viewport.getBoundingClientRect();
          const picture = slideImage.getBoundingClientRect();
          const inset = bounds.width < 700 ? 12 : 16;
          const left = Math.max(bounds.left, picture.left);
          const top = Math.max(bounds.top, picture.top);
          const right = Math.min(bounds.right, picture.right);
          const bottom = Math.min(bounds.bottom, picture.bottom);
          const size = Math.min(bounds.width < 700 ? 90 : 120,
            right - left - inset * 2, bottom - top - inset * 2);

          if (size < 16) {
            element.style.visibility = "hidden";
            return;
          }

          element.style.left = `${Math.round(left - bounds.left + inset)}px`;
          element.style.top = `${Math.round(top - bounds.top + inset)}px`;
          element.style.width = `${Math.round(size)}px`;
          element.style.visibility = "visible";
        };

        const schedule = () => {
          if (!frame) frame = requestAnimationFrame(update);
        };

        for (const name of ["afterSetContent", "change", "loadComplete",
          "openingAnimationEnd", "resize", "zoomPanUpdate"]) {
          pswp.on(name, schedule);
        }
        pswp.on("destroy", () => {
          if (frame) cancelAnimationFrame(frame);
        });
        schedule();
      }
    });
  });
}, { capture: true });
  } catch(e) { console.error(e); }
})();

})();
